export default{
    lista:{
        method:'get',
        url:'folhar/auto/lista'
    },
    listatrabalhador:{
        method:'get',
        url:'trabalhador/pesquisa{/id}'
    },
    listatomador:{
        method:'get',
        url:'tomador/lista'
    },
    cadastra:{
        method:'post',
        url:'folhar/auto/cadastro'
    },
    delete:{
        method:'delete',
        url:'comissionado/deletar{/id}'
    },
    editar:{
        method:'get',
        url:'comissionado/editar{/id}'
    },
    update:{
        method:'post',
        url:'comissionado/update'
    }
}
